import React from 'react';
import { useSelector } from 'react-redux';
import Popup from '../../../../components/ui/popup/Popup';
import HeaderPopup from '../../../../components/ui/popup/headerPopup/HeaderPopup';
import Icon from '../../../../components/ui/icons/Icon';
import iconsList from '../../../../components/ui/icons/iconsList';
import ContentsPopup from '../../../../components/ui/popup/contentPopup/ContentPopup';
import finalPopupWasThereLaunchImg from '../../../../assets/FinalStage/confirm.png';
import classes from './FinalLaunchPopup.module.css';

const FinalLaunchPopup = ({ onClose, onConfirm, lockBtnWhenChackIsAllowed }) => {

  const { texts } = useSelector((state) => state.translate);
  const handleNoLaunchYet = () => {
    onClose();
  };

  return (
    <Popup close={onClose} dropClass={classes.finalPopup}  >
      <ContentsPopup className={classes.popupContent}>
        <div className={classes.content}>
          <img src={finalPopupWasThereLaunchImg} alt={texts.finalPopupWasThereLaunch} className={classes.confirmImg} />
          <p className={classes.question}>{texts.finalPopupWasThereLaunch}</p>
        </div>
        <div className={classes.buttonWrapper}>
          <button onClick={handleNoLaunchYet} className={classes.buttonSecondary}>
            <span className={classes.buttonText}> {texts.finalPopupNoLaunchYet}</span>
          </button>
          <div className={classes.buttonWrapper}>
            <button type="button" className={classes.button} onClick={onConfirm} disabled={lockBtnWhenChackIsAllowed}>
              <Icon name={iconsList.play} size={'40px'} />
              <p className={classes.text}>{texts.playNow}</p>
            </button>
          </div>
        </div>
      </ContentsPopup>
    </Popup>
  );
};



export default FinalLaunchPopup;
